import React, { useRef } from "react"; import "bootstrap/dist/css/bootstrap.min.css"; import { Formik, Field, ErrorMessage, FieldArray } from "formik";
import { Form, Table, InputGroup } from "react-bootstrap"; import * as OFMSUI from "react-bootstrap"; import Swal from "sweetalert2"; import { useState } from "react";
import HousingService from "../../../Services/HousingService"; import * as Yup from "yup"; import MuiAlert from "@mui/material/Alert"; import NavigationServicesHeader from "../../../Header/NavigationServicesHeader";
import { AiFillPlusCircle, AiFillMinusCircle } from "react-icons/ai"; import { cloud_url } from "../../../Services/Configuration"; import { useHistory } from "react-router-dom"; import axios from "axios"; import { FaFastBackward } from "react-icons/fa";
import ClassificationHeads from "./ClassificationHeads";

// import './background.css';
function GenerationJournal() {
  const formReference = useRef(); const [selectedHeadIds, setSelectedHeadIds] = useState([]); const [opensnackbar, setOpensnackbar] = React.useState(false);
  const [opensnackbarsubheadremove, setOpensnackbarsubheadremove] = React.useState(false);
  const [chequeddreceiptnoflag, setchequeddreceiptnoflag] = useState(false);
  const [mode, setmode] = useState(); const [headercount, setHeadercount] = useState(1); const [headNamesList, setheadNamesList] = useState();
  const [bankList, setbankList] = useState(); const [subheadresdata, setSubheadresdata] = useState(); const [Modevalidationflag, setModevalidationflag] = useState(false);
  const [number, setnumber] = useState(0);
  const [Headsum, setHeadSum] = useState(); const [transactionId, setTransactionId] = useState(); const [headSelected, setHeadSelected] = useState(false);
  const history = useHistory(); const [ClassBudget, setClassBudget] = useState([]); const [HeadsClassifcation, setHeadsClassifcation] = useState();

  React.useEffect(() => {
    let params = { save_flag_Payment_Receipts_Journal: "Journal", };
    HousingService.getPaymentReceiptId(params).then((res) => { const id = res.data[0].payment_receipt_id; setTransactionId(id); });
    handleHeadNames();
    HousingService.ClassificationBudget().then((res) => { setClassBudget(res.data); });
  }, []);

  const NumberValidation = (e) => {
    var keyCode = e.keyCode === 0 ? e.charCode : e.keyCode;

    var value = Number(e.target.value + e.key) || 0;

    if (keyCode >= 48 && keyCode <= 57) {
      return isValidNumber(value);
    } else {
      e.preventDefault();
    }

    return false;
  };
  function isValidNumber(number) {
    return 0 <= number && number <= 10;
  }

  function addingHeaders(e, values, setValues) {
    const dummy_journal_voucher_heads_Req = [
      ...values.dummy_journal_voucher_heads_Req,
    ];
    const addHeaders = e.target.value || 0;

    for (let i = 1; i <= number; i++) {
      dummy_journal_voucher_heads_Req.push({ headid: "", debit: "", credit: "", subheadid: "", });
      setHeadercount(headercount + 1);
      setValues({ ...values, dummy_journal_voucher_heads_Req });
      setHdnm();
    }
  }

  const changeNumber = (e) => { setnumber(e.target.value); };


  const handleHeadNames = () => {
    HousingService.fetchHeadNamesDropdowns().then((res) => {
      setSubheadresdata(res.data);
      if (res.data) {
        let options = res.data.map((item, i) => {
          return (<option key={i} value={item.headid}> {item.heads} </option>);
        });
        setheadNamesList(options);
      }
    });
  };
  const [lstsubhead, setLstsubhead] = useState([]);
  const [hdnm, setHdnm] = useState();
  const [theArray, setTheArray] = useState([]);
  const [subhead, setSubheadName] = useState([]);
  const subhandleHeadNames = (e, field, values, setFieldValue, i) => {
    field.onChange(e);
    const selectedheadname = e.target.value;
    HousingService.fetchSubHeadName(selectedheadname).then((res) => {
      if (res.data) {
        let options = res.data.map((item, i) => {
          if (item !== null) {
            return (<option key={i} value={item.subheadseqid}> {item.subheads} </option>);
          }
        });
        setFieldValue(`dummy_journal_voucher_heads_Req.${i}.subHeadOptions`, options);
      }

    });
  };
  const getPdf = (payment_receipt_id) => {
    HousingService.getjournalpdf(payment_receipt_id).then((res) => {
      const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
      let tab = window.open(); tab.location.href = url;
      setTimeout(() => { resetForm(); window.location.reload(); }, 2000);
    });
  };

  const [repeatsubhead, setRepeatsubhead] = useState();
  const subNames = (e, field, values, setValues) => {
    field.onChange(e);
    const subheadvalue = e.target.value;
    setRepeatsubhead(subheadvalue);
  };
  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });
  const handleClosesnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpensnackbar(false);
  };
  const handleClosesnackbarsubheadremove = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpensnackbarsubheadremove(false);
  };
  function removingHeaders(e, values, setValues) {
    const dummy_journal_voucher_heads_Req = [...values.dummy_journal_voucher_heads_Req,];
    if (headercount > 0) {
      dummy_journal_voucher_heads_Req.pop({ headid: "", subheadid: "", debit: "", credit: "", });
      setValues({ ...values, dummy_journal_voucher_heads_Req });
      setOpensnackbarsubheadremove(true);
      setHeadercount(headercount - 1);
    } else {
      setOpensnackbar(true);
    }
  }
  const today = new Date().toISOString().split('T')[0];

  const onChangePaymentMode = (e, field, values, setValues) => {
    setModevalidationflag(true);
    const receivedmode = e.target.value; setmode(receivedmode); setValues({ ...values, receivedmode }); field.onChange(e);
    if (receivedmode) { setchequeddreceiptnoflag(true); } else { setchequeddreceiptnoflag(false); }
  };

  function addHead(e, values, setValues) {
    const dummy_journal_voucher_heads_Req = [...values.dummy_journal_voucher_heads_Req,];
    const addHeaders = e.target.value || 0;
    const lengthsubhead = values.dummy_journal_voucher_heads_Req.length;
    var headsum = 0;
    for (let i = 0; i < lengthsubhead; i++) {
      const subheadval = values.dummy_journal_voucher_heads_Req[i];
      headsum = parseInt(subheadval.debit) + headsum;
    }
    setHeadSum(headsum);
    dummy_journal_voucher_heads_Req.push({ headid: "", subheadid: "", credit: "", debit: "", });
    setValues({ ...values, dummy_journal_voucher_heads_Req });
    setHeadercount(headercount + 1);
  }

  const showNotification = (type, message) => {
    if (type === "success") {
      Swal.fire("Success", message, "success");
    }
    else if (type === "error") {
      Swal.fire("Error", message, "error");
    }
    else if (type === "warning") {
      Swal.fire("Warning", message, "warning");
    }
    else if (type === "info") { Swal.fire("info", message, "info"); }
  };

  const ref = React.createRef();
  return (
    <>
      <NavigationServicesHeader />
      <Formik
        innerRef={formReference}
        initialValues={{
          payment_receipt_id: transactionId, date: "", voucher_id: "", description: "", debit: "", credit: "", file: "",
          dummy_journal_voucher_heads_Req: [{ headid: "", subheadid: "", debit: "", credit: "", },],
        }}
        validationSchema={Yup.object({
          date: Yup.date().required(),
          // voucher_id: Yup.string().required(),
          voucher_id: Yup.string()
            .required("Voucher No is required")
            .test("greater-than-300", "Voucher No. must be greater than 300.", (value) => {
              if (!value) return false;
              return parseInt(value, 10) > 300;
            }),
          file: Yup.string().required("File is required"), description: Yup.string().required(),
          dummy_journal_voucher_heads_Req: Yup.array().of(Yup.object().shape({ headid: Yup.string().required("Head ID is required"), credit: Yup.number().required("Credit amount is required").typeError("Credit amount should be a number"), debit: Yup.number().required("Debit amount is required").typeError("Debit amount should be a number"), })),
        })}
        onSubmit={async (values, { resetForm }) => {
          values.payment_receipt_id = transactionId;
          let debit = values?.dummy_journal_voucher_heads_Req?.reduce((sum, row) => parseFloat(row?.debit || 0) + sum, 0);
          let credit = values?.dummy_journal_voucher_heads_Req?.reduce((sum, row) => parseFloat(row?.credit || 0) + sum, 0);
          values.debit = debit;
          values.credit = credit;
          if (debit === 0 || credit === 0) { showNotification("warning", "Enter amount before submitting"); return; }
          if (debit !== credit) {
            showNotification("warning", "Debit and Credit Should be equal");
            return;
          }
          try {
            Swal.fire({ text: "Do you want Submit?", icon: "success", showCancelButton: true, confirmButtonColor: "#3085d6", cancelButtonColor: "#d33", confirmButtonText: "Yes", }).then((result) => {
              if (result.isConfirmed) {
                let file = document.getElementById("file").files[0];
                let formData = new FormData();
                formData.append("file", file);
                HousingService.fileUploadUrlJV(formData).then((res) => {
                  if (res.data !== null && res.data !== undefined) {
                    values.upload_copy = res.data
                    HousingService.salaryGenerationJournalInsertion(values).then(
                      async (res) => {
                        if (res?.data?.SCODE === "01") {
                          showNotification("success", "Submitted successfully");
                          await getPdf(values?.payment_receipt_id);
                          setTimeout(() => { resetForm(); window.location.reload(); }, 1000);
                        }
                        else if (res?.data?.SCODE == "04") {
                          showNotification("warning", res?.data?.SDESC);
                        }
                        else {
                          showNotification("error", res?.data?.SDESC);
                        }

                      }
                    );
                  }
                })
              }
            });
          } catch (error) {
            console.log(error)
            showNotification("error", "File name should not contain symbols or special characters.");

          }
        }}
      >
        {({ errors, values, touched, setValues, resetForm, handleSubmit, setFieldValue, handleChange, }) => (
          <Form onSubmit={handleSubmit}>
            <OFMSUI.Container fluid style={{ width: "90%" }}>
              <OFMSUI.Row>
                <OFMSUI.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className="page-titlespacing" >
                  <div className="inner-herbpage-service-title1"> <h1 style={{ marginLeft: "-15px" }}> Generation of Journal Voucher </h1> </div>
                </OFMSUI.Col>
                <OFMSUI.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className="page-titlespacing" >
                  <button className="btn btn-primary btn-sm" style={{ textAlign: "right", float: "right", marginTop: "30px", backgroundColor: "#603913", borderColor: "#603913", color: "#fff" }} type="reset" onClick={() => history.goBack()} >
                    <FaFastBackward /> &nbsp;Back
                  </button>
                  <div className="d-grid  "></div>
                </OFMSUI.Col>
              </OFMSUI.Row>
            </OFMSUI.Container>

            <OFMSUI.Container className="outer-page-content-container" fluid style={{ width: "90%" }}>
              <ClassificationHeads />
              <OFMSUI.Row className="p-4 ">
                <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="" >
                  <label> <b>Transaction Id No</b> </label> <span className="mandatory" style={{ color: "red" }}>  * </span>
                  <Field value={transactionId} name="payment_receipt_id" className={touched.payment_receipt_id && errors.payment_receipt_id ? "form-control is-invalid" : "form-control"} type="text" disabled={true} />
                  {touched.payment_receipt_id && errors.payment_receipt_id ? (<div className="invalid-feedback"> {errors.payment_receipt_id} </div>) : null}
                </OFMSUI.Col>

                <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="" >
                  <label> <b>Date</b> </label> <span className="mandatory" style={{ color: "red" }}>  * </span>
                  <Field name="date" className={touched.date && errors.date ? "form-control is-invalid" : "form-control"} type="date" max={today} min="2023-01-01" />
                  {touched.date && errors.date ? (<div className="invalid-feedback">{errors.date}</div>) : null}
                </OFMSUI.Col>
                <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="" >
                  <label> <b>Voucher No</b> </label> <span className="mandatory" style={{ color: "red" }}>  * </span>
                  <Field name="voucher_id" className={touched.voucher_id && errors.voucher_id ? "form-control is-invalid" : "form-control"} type="text" onKeyPress={(e) => NumberValidation(e)} />
                  {touched.voucher_id && errors.voucher_id ? (<div className="invalid-feedback">{errors.voucher_id}</div>) : null}
                </OFMSUI.Col>
                <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="" >
                  <label> <b>Description</b> </label> <span className="mandatory" style={{ color: "red" }}>  * </span>
                  <Field style={{ height: "38px" }} name="description" as="textarea" className={touched.description && errors.description ? "form-control is-invalid" : "form-control"} />
                  {touched.description && errors.description ? (<div className="invalid-feedback">{errors.description}</div>) : null}
                </OFMSUI.Col>
              </OFMSUI.Row>
              <OFMSUI.Row className="p-4" style={{ marginTop: "-25px" }}>
                <Table striped bordered hover> <tbody> <thead style={{ color: "#004687", marginRight: "85%", backgroundColor: "red", }} className="fw-bold" ></thead> </tbody> </Table>
                <FieldArray name="dummy_journal_voucher_heads_Req">
                  {({ form, push, remove }) => {
                    const voucherHeads = values.dummy_journal_voucher_heads_Req
                    return (<Table striped bordered hover>
                      <thead className="fw-bold">
                        <tr className="table_countshead"> <td>S.no</td> <td style={{ width: "50%" }}>Heads Name</td> <td style={{ width: "15%" }}>SubHeads Name</td> <td>Debit</td> <td>Credit</td> <td>Actions</td> </tr>
                      </thead>
                      <tbody>
                        {values.dummy_journal_voucher_heads_Req.map(
                          (HeadersList, i) => {
                            const headId =
                              values.dummy_journal_voucher_heads_Req[i].headid;
                            const isHeadIdSelected =
                              selectedHeadIds.includes(headId);
                            const dummy_journal_voucher_heads_ReqErrors =
                              (errors.dummy_journal_voucher_heads_Req?.length &&
                                errors.dummy_journal_voucher_heads_Req[i]) ||
                              {};
                            const dummy_journal_voucher_heads_ReqTouched =
                              (touched.dummy_journal_voucher_heads_Req?.length &&
                                touched.dummy_journal_voucher_heads_Req[i]) ||
                              {};
                            return (
                              <>
                                <tr key={i}>
                                  <td>{i + 1}</td>
                                  <td>
                                    <Field className="form-control" name={`dummy_journal_voucher_heads_Req.${i}.headid`} >
                                      {({ field }) => (
                                        <select
                                          {...field}
                                          onChange={(e) => {
                                            subhandleHeadNames(e, field, values, setFieldValue, `${i}`);
                                            setHeadSelected(e.target.value !== "0");
                                            const classification = subheadresdata.filter((item) => item.headid === e.target.value)[0]?.classification_id
                                            setHeadsClassifcation(classification);
                                            console.log("class", classification)
                                          }}
                                          className={"form-control" + (dummy_journal_voucher_heads_ReqErrors.headid && dummy_journal_voucher_heads_ReqTouched.headid ? " is-invalid" : "")}
                                        >

                                          <option value="0">--Select--</option>
                                          {headNamesList}
                                        </select>
                                      )}
                                    </Field>
                                    <ErrorMessage name={`dummy_journal_voucher_heads_Req.${i}.headid`} component="div" className="invalid-feedback" />
                                  </td>

                                  <td>
                                    <Field name={`dummy_journal_voucher_heads_Req.${i}.subheadid`} >
                                      {({ field }) => (
                                        <select
                                          {...field}
                                          onChange={(e) => subNames(e, field, values, setValues)}
                                          className={"form-control" + (dummy_journal_voucher_heads_ReqErrors.subheadid && dummy_journal_voucher_heads_ReqTouched.subheadid ? " is-invalid" : "")}
                                        >
                                          <option value="0">--Select--</option>
                                          {HeadersList?.subHeadOptions}
                                        </select>
                                      )}
                                    </Field>
                                  </td>
                                  <td>
                                    <Field
                                      name={`dummy_journal_voucher_heads_Req.${i}.debit`}
                                      id="debit"
                                      {...ref}
                                      type="text"
                                      data-debitObjId={i}
                                      onKeyPress={(e) => NumberValidation(e)}
                                      onChange={(e) => {
                                        handleChange(e); // Keep default Formik change handling
                                        setFieldValue(`dummy_journal_voucher_heads_Req.${i}.credit`, "0"); // Reset credit
                                      }}
                                      className={"form-control" + (dummy_journal_voucher_heads_ReqErrors.debit && dummy_journal_voucher_heads_ReqTouched.debit ? " is-invalid" : "")}
                                    />
                                    <ErrorMessage name={`dummy_journal_voucher_heads_Req.${i}.debit`} component="div" className="invalid-feedback" />
                                  </td>
                                  <td>
                                    <Field
                                      name={`dummy_journal_voucher_heads_Req.${i}.credit`}
                                      id="credit"
                                      className={"form-control" + (dummy_journal_voucher_heads_ReqErrors.credit && dummy_journal_voucher_heads_ReqTouched.credit ? " is-invalid" : "")}
                                      data-debitObjId={i}
                                      type="text"
                                      onKeyPress={(e) => NumberValidation(e)}
                                      onChange={(e) => {
                                        handleChange(e); // Keep default Formik change handling
                                        setFieldValue(`dummy_journal_voucher_heads_Req.${i}.debit`, "0"); // Reset debit
                                      }}
                                    />
                                    <ErrorMessage name={`dummy_journal_voucher_heads_Req.${i}.credit`} component="div" className="invalid-feedback" />
                                  </td>
                                  <td>
                                    <AiFillPlusCircle
                                      onClick={() => { setSelectedHeadIds([...selectedHeadIds, headId,]); push({ headid: "", subheadid: "", credit: "", }); }}
                                      style={{ fontSize: "21px", color: "green", }}
                                    />
                                    {i > 0 && (<AiFillMinusCircle onClick={() => remove(i)} style={{ fontSize: "21px", color: "red", }} />)}
                                  </td>
                                </tr>
                              </>
                            );
                          }
                        )}
                      </tbody>
                      <tfoot>
                        <tr>
                          <th colSpan={3}>Total</th>
                          <th>
                            {values?.dummy_journal_voucher_heads_Req?.reduce((sum, row) => parseFloat(row?.debit || 0) + sum, 0).toLocaleString("en-IN", { style: "currency", currency: "INR", })}
                          </th>
                          <th>
                            {values?.dummy_journal_voucher_heads_Req?.reduce((sum, row) => parseFloat(row?.credit || 0) + sum, 0).toLocaleString("en-IN", { style: "currency", currency: "INR", })}
                          </th>
                        </tr>
                      </tfoot>
                    </Table>)
                  }}
                </FieldArray>
              </OFMSUI.Row>
              <OFMSUI.Row xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="m-2" >
                <div> <lable> <b>File Upload (File name should not contain symbols or special characters.) </b> <span className="text-danger">*</span> </lable>
                  <InputGroup> <input type="file" name="file" id="file" onChange={(e) => { handleChange(e) }} className={touched.file && errors.file ? "form-control is-invalid" : "form-control"} />
                  </InputGroup>
                  <ErrorMessage name="file" component="div" className="text-danger" /> </div>
              </OFMSUI.Row>
              <br></br>
              <OFMSUI.Row className="m-2"> <OFMSUI.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1} className="" >
                <div className="d-grid  "> <button className="btn btn-secondary " type="reset" onClick={resetForm} > Clear </button> </div>
              </OFMSUI.Col>
                <center> <OFMSUI.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1}> <button className="btn btn-success btn-sm" type="submit" > Submit </button> </OFMSUI.Col> </center>
              </OFMSUI.Row>
            </OFMSUI.Container>
          </Form>
        )}
      </Formik>
    </>
  );
}
export default GenerationJournal;
